import { flow } from "fp-ts/es6/function"
import { adjust, always, append, cond, evolve, F, identity, ifElse, is, map, T } from "ramda"
import { useCallback, useState } from "react"

export const isJSON = (string) => {
  try {
    JSON.parse(string)
  } catch (_error) {
    return false
  }

  return true
}

export const messages = flow(
  map(flow(map(adjust(1, ifElse(is(Function), identity, always))), append([T, F]), cond)),
  evolve,
)

export const useWithInput = (validator, inputCallback) => {
  const [error, setError] = useState(false)

  const handleInput = useCallback(
    (_, value) => {
      setError(validator(value))
      inputCallback && inputCallback(value)
    },
    [validator, inputCallback],
  )

  return [error, handleInput]
}
